import styles from './Textarea.module.css';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    error?: string;
    helperText?: string;
    fullWidth?: boolean;
    resize?: 'none' | 'both' | 'horizontal' | 'vertical';
}

export const Textarea = ({
    label,
    error,
    helperText,
    fullWidth = false,
    resize = 'vertical',
    className = '',
    disabled = false,
    rows = 4,
    ...props
}: TextareaProps) => {
    return (
        <div className={`${styles.textareaField} ${error ? styles.textareaFieldError : ''} ${fullWidth ? styles.fullWidth : ''}`}>
            {label && <label htmlFor={props.id}>{label}</label>}
            <textarea
                className={`${styles.textarea} ${styles[`resize-${resize}`]} ${className}`}
                disabled={disabled}
                rows={rows}
                {...props}
            />
            {error && <span className={styles.errorMessage}>{error}</span>}
            {!error && helperText && <span className={styles.helperText}>{helperText}</span>}
        </div>
    );
};
